import Radar from 'radar-sdk-js';

import { log } from './map-logger';

// ─── Helpers ────────────────────────────────────────────────────────────────

/**
 * Initializes Radar SDK.
 */
export async function initializeRadarIfNeeded(publishableKey: string): Promise<void> {
  try {
    Radar.initialize(publishableKey, { logLevel: 'error' });
  } catch (error) {
    log.error('Failed to initialize Radar', error);
  }
}

/**
 * Creates a Radar map style URL.
 */
export async function createRadarStyleURL(
  publishableKey: string,
  style: string = DEFAULT_STYLE,
): Promise<string> {
  return `${RADAR_HOST}/maps/styles/${style}?publishableKey=${publishableKey}`;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_STYLE = 'radar-default-v1';
const RADAR_HOST = 'https://api.radar.io';
